// WRAP LUXURY · Noir & Gold behaviour (reveal, counters, parallax, testimonials, pop-up, product helpers).
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const store = {
    get(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
  };

  /* Hero entrance */
  requestAnimationFrame(() => requestAnimationFrame(() => document.documentElement.classList.add('wl-ready')));

  /* Reveal on scroll + craft steps */
  const revealIO = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
      }), { rootMargin: '0px 0px -8% 0px', threshold: 0.08 })
    : null;
  const observeReveals = (root = document) => {
    root.querySelectorAll('[data-wl-reveal]:not(.is-in), [data-wl-step]:not(.is-in)').forEach((el) => {
      if (!revealIO || reduce) el.classList.add('is-in');
      else revealIO.observe(el);
    });
  };

  /* Count-up numbers */
  const countIO = 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => entries.forEach((e) => {
        if (!e.isIntersecting) return;
        countIO.unobserve(e.target);
        const el = e.target;
        const to = parseFloat(el.dataset.wlCount);
        const suffix = el.dataset.wlSuffix || '';
        if (isNaN(to) || reduce) return;
        const t0 = performance.now();
        const tick = (t) => {
          const k = Math.min(1, (t - t0) / 1800);
          el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))).toLocaleString() + suffix;
          if (k < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }), { threshold: 0.3 })
    : null;
  const observeCounts = (root = document) => {
    if (countIO) root.querySelectorAll('[data-wl-count]').forEach((el) => countIO.observe(el));
  };

  /* Parallax */
  const runParallax = () => {
    document.querySelectorAll('[data-wl-parallax]').forEach((el) => {
      const r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > innerHeight) return;
      const k = Math.max(-1, Math.min(1, (r.top + r.height / 2 - innerHeight / 2) / innerHeight));
      el.style.transform = `translate3d(0, ${k * -(+el.dataset.wlParallax || 60)}px, 0)`;
    });
  };
  if (!reduce) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { runParallax(); ticking = false; });
    }, { passive: true });
  }

  /* Testimonials */
  if (!customElements.get('wl-quotes')) {
    customElements.define('wl-quotes', class extends HTMLElement {
      connectedCallback() {
        this.quotes = Array.from(this.querySelectorAll('.wl-quote'));
        this.dots = Array.from(this.querySelectorAll('.wl-dots button'));
        this.i = 0;
        if (this.quotes.length < 2) return;
        this.addEventListener('click', (e) => {
          const dir = e.target.closest('[data-dir]');
          const dot = e.target.closest('[data-i]');
          if (dir) this.go(this.i + Number(dir.dataset.dir));
          if (dot) this.go(Number(dot.dataset.i));
        });
        this.start();
      }
      start() {
        clearInterval(this.timer);
        if (!reduce) this.timer = setInterval(() => this.go(this.i + 1, true), (Number(this.dataset.interval) || 7) * 1000);
      }
      go(n, auto) {
        this.quotes[this.i].classList.remove('is-active');
        this.dots[this.i] && this.dots[this.i].classList.remove('is-active');
        this.i = (n + this.quotes.length) % this.quotes.length;
        this.quotes[this.i].classList.add('is-active');
        this.dots[this.i] && this.dots[this.i].classList.add('is-active');
        if (!auto) this.start();
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  /* Top bar: fade between messages */
  if (!customElements.get('wl-rotator')) {
    customElements.define('wl-rotator', class extends HTMLElement {
      connectedCallback() {
        this.items = Array.from(this.querySelectorAll('.wl-topbar__msg'));
        this.i = 0;
        if (this.items.length < 2 || reduce) return;
        const ms = (Number(this.dataset.interval) || 4) * 1000;
        this.timer = setInterval(() => {
          if (this.matches(':hover')) return;
          this.items[this.i].classList.remove('is-active');
          this.i = (this.i + 1) % this.items.length;
          this.items[this.i].classList.add('is-active');
        }, ms);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  /* Welcome pop-up: once per session, after a delay or on exit intent */
  if (!customElements.get('wl-popup')) {
    customElements.define('wl-popup', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => { if (e.target.closest('[data-wl-close]')) this.close(); });
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.hidden) this.close(); });
        if (window.Shopify && Shopify.designMode) return;
        // After a sign-up the page reloads: show the thank-you straight away.
        if (this.querySelector('[data-wl-popup-done]') || this.querySelector('.wl-news__error')) { this.open(true); return; }
        if (store.get('wl-popup-seen')) return;
        this.timer = setTimeout(() => this.open(), (Number(this.dataset.delay) || 14) * 1000);
        if (this.dataset.exit === 'true') {
          this.onExit = (e) => { if (!e.relatedTarget && e.clientY < 8) this.open(); };
          document.addEventListener('mouseout', this.onExit);
        }
      }
      open(force) {
        if (!force && (store.get('wl-popup-seen') || document.body.classList.contains('overflow-hidden'))) return;
        store.set('wl-popup-seen', '1');
        clearTimeout(this.timer);
        if (this.onExit) document.removeEventListener('mouseout', this.onExit);
        this.hidden = false;
        requestAnimationFrame(() => requestAnimationFrame(() => this.classList.add('is-open')));
        const input = this.querySelector('input[type="email"]');
        if (input) setTimeout(() => input.focus({ preventScroll: true }), 400);
      }
      close() {
        this.classList.remove('is-open');
        setTimeout(() => { this.hidden = true; }, 500);
      }
    });
  }
  document.addEventListener('shopify:section:select', (e) => {
    const p = e.target.querySelector('wl-popup');
    if (p) p.open(true);
  });
  document.addEventListener('shopify:section:deselect', (e) => {
    const p = e.target.querySelector('wl-popup');
    if (p) p.close();
  });

  /* Product page: gift note toggle */
  document.addEventListener('change', (e) => {
    const box = e.target.closest('[data-wl-gift-toggle]');
    if (!box) return;
    const wrap = box.closest('.wl-gift');
    const note = wrap.querySelector('textarea');
    wrap.classList.toggle('is-on', box.checked);
    note.disabled = !box.checked;
    if (box.checked) note.focus();
  });

  /* Product page: delivery estimate (cut-off hour and working days set on the block) */
  const addWorkDays = (date, n, skip) => {
    const d = new Date(date);
    while (n > 0) { d.setDate(d.getDate() + 1); if (!skip.includes(d.getDay())) n--; }
    return d;
  };
  const fmt = (d) => d.toLocaleDateString(document.documentElement.lang || undefined, { weekday: 'short', day: 'numeric', month: 'short' });
  const tickDelivery = () => {
    document.querySelectorAll('[data-wl-delivery]').forEach((el) => {
      const cutoff = Number(el.dataset.cutoff) || 16;
      const min = Number(el.dataset.min) || 2;
      const max = Number(el.dataset.max) || 4;
      const skip = (el.dataset.skip || '5').split(',').filter(Boolean).map(Number);
      const now = new Date();
      const cut = new Date(now); cut.setHours(cutoff, 0, 0, 0);
      const today = now < cut && !skip.includes(now.getDay());
      const ship = today ? now : addWorkDays(now, 1, skip);
      const cutEl = el.querySelector('[data-cutoff-text]');
      const etaEl = el.querySelector('[data-eta-text]');
      if (cutEl) {
        if (today) {
          const m = Math.floor((cut - now) / 60000);
          cutEl.innerHTML = `Order within <b>${Math.floor(m / 60)}h ${m % 60}m</b> for dispatch <b>today</b>`;
        } else {
          cutEl.innerHTML = `Order now for dispatch on <b>${fmt(ship)}</b>`;
        }
      }
      if (etaEl) etaEl.innerHTML = `Estimated delivery <b>${fmt(addWorkDays(ship, min, skip))} – ${fmt(addWorkDays(ship, max, skip))}</b>`;
    });
  };

  /* Product page: Buy it now (add the chosen variant, then go straight to checkout) */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-wl-buy-now]');
    if (!btn) return;
    const form = document.getElementById(btn.dataset.wlBuyNow);
    const submit = form && form.querySelector('[type="submit"]');
    if (!form || (submit && submit.disabled)) return;
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      });
      const data = await res.json();
      if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not add this piece.');
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'checkout';
    } catch (err) {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
      const wrap = form.closest('product-form') && form.closest('product-form').querySelector('.product-form__error-message-wrapper');
      if (wrap) { wrap.hidden = false; wrap.querySelector('.product-form__error-message').textContent = err.message; }
      else alert(err.message);
    }
  });
  // Keep Buy it now in step with Add to cart (sold out / unavailable variants)
  const syncBuyNow = () => {
    document.querySelectorAll('[data-wl-buy-now]').forEach((btn) => {
      const form = document.getElementById(btn.dataset.wlBuyNow);
      const submit = form && form.querySelector('[type="submit"]');
      if (!submit || btn.dataset.wlWatched) return;
      btn.dataset.wlWatched = '1';
      const mirror = () => { if (!btn.hasAttribute('aria-busy')) btn.disabled = submit.disabled; };
      new MutationObserver(mirror).observe(submit, { attributes: true, attributeFilter: ['disabled'] });
      mirror();
    });
  };

  const init = (root) => {
    syncBuyNow(); observeReveals(root); observeCounts(root); runParallax(); tickDelivery(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  setInterval(tickDelivery, 30000);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
